module.exports = __webpack_public_path__ + "img/picture_vipkcbj.e2c12ad7.png";